/* 同名对象将会覆盖盘古的语言文件对象，取名慎重。建议所有对象以工程名为前缀 */
var zh = {
    language: {
        name: '中文',
        id: 'zh'
    },
    subsytem: {
        CURSYS: '当前系统'
    }
};
export default zh;
